/**
 * Sends logs to Datadog logging.
 */
export const datadogLoggerStream = (datadogLogger) => (event) => datadogLogger[event.level](event.message, event.error ? Object.assign(Object.assign({}, event.context), { error: event.error }) : event.context);
//# sourceMappingURL=datadogLoggerStream.js.map